var _circle, _circle2, _circle3, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuybackLight = function SvgBuybackLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 27.5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 28.046,
    stroke: "#313154",
    strokeOpacity: 0.1,
    strokeWidth: 1.091
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 13.75,
    fill: "url(#buyback-light_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#buyback-light_svg__b)",
    d: "M29.5 37.139a7.639 7.639 0 1 0 0-15.278 7.639 7.639 0 0 0 0 15.278"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#buyback-light_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#buyback-light_svg__d)",
    fillRule: "evenodd",
    d: "M22.844 19.246a12.15 12.15 0 0 1 6.655-1.968c6.75 0 12.223 5.472 12.223 12.222s-5.473 12.222-12.223 12.222S17.277 36.25 17.277 29.5a3.056 3.056 0 1 0-6.111 0c0 10.125 8.208 18.333 18.333 18.333 10.126 0 18.334-8.208 18.334-18.333s-8.208-18.333-18.334-18.333c-3.678 0-7.11 1.086-9.983 2.954l-1.244-1.915a.611.611 0 0 0-1.09.133l-2.595 7.484a.61.61 0 0 0 .526.81l7.893.672a.611.611 0 0 0 .564-.941z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "buyback-light_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-123.69 22.644 6.856)scale(16.5254 16.0678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F88A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#859CDA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#859CDA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#859CDA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "buyback-light_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(54.951 -5.418 22.989)scale(62.5177)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#796EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "buyback-light_svg__b",
    x1: 37.139,
    x2: 9.502,
    y1: 37.139,
    y2: 28.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#989EC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3267"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "buyback-light_svg__c",
    width: 43.456,
    height: 43.457,
    x: 7.771,
    y: 7.772,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.698
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_404_3282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_404_3282",
    result: "shape"
  })))));
};
export { SvgBuybackLight as ReactComponent };
export default "data:image/svg+xml;base64,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";